import React, { ComponentProps, FC } from 'react';

import { useFullscreen } from '@/scenarios/legacy-player/components/PlayerSkin/parts/Layout/hooks/useFullscreen';

import { FullSizePlayerLayout } from '../../feature-player/ui/skin/full-size-player-layout/component';
import { useTogglePlayWithIndicator } from '../../feature-player/hooks/skin/use-toggle-play-with-indicator';

type Props = Omit<ComponentProps<typeof FullSizePlayerLayout>, 'onClick' | 'onDoubleClick'>;

export const VodLayout: FC<Props> = (props) => {
    const { toggleFullscreen } = useFullscreen();
    const { togglePlay } = useTogglePlayWithIndicator();

    return (
        <FullSizePlayerLayout onClick={togglePlay} onDoubleClick={toggleFullscreen} {...props} />
    );
};
